import { createContext } from "react";

import { LeagueNaming } from "@/types/league.types";

export const LeagueNamingContext = createContext<LeagueNaming>("tour");
